import { valorParaMostrar } from '../../lib/campos';
import React, { useState } from 'react';
import { DateBadge } from '../../components/base';
import { QuickStatusPopup, SnoozePicker, TempPicker } from '../../components/pickers';
import { CARD_PADRAO, LEAD_ORIGINS, WA_ICON, WA_TEMPLATES } from '../../lib/constantes';
import { CopiarContato } from './CopiarContato';
import { rotuloEmpresa } from '../../lib/empresas';
import { fmt, fmtDateOnly, fmtWhatsApp, getDateStatus, getRecMonths, normalizeUrl, renderWaTemplate, waLink } from '../../lib/formato';
import { diasNaEtapa, repescagemAberta, statusEsfriando } from '../../lib/pipeline';

function KanbanCard({ lead, onClick, draggable: isDraggable, onTemperatureChange, onAddInteraction, onClearDate, onSnoozeDate, company = '', camposCustom = [], campos = CARD_PADRAO }) {
  const [cardTab, setCardTab] = useState('info');
  const [showQuickStatus, setShowQuickStatus] = useState(false);
  const [showSnoozeInfo, setShowSnoozeInfo] = useState(false);
  const [showSnoozeStatus, setShowSnoozeStatus] = useState(false);
  const isFinalStage = ['fechado','perdido'].includes(lead.stage);
  // Fila de repescagem vencida: pisca até alguém abrir o lead ou registrar interação.
  const repescando = repescagemAberta(lead, null);
  const ds = (lead.next_contact_date && !isFinalStage) ? getDateStatus(lead.next_contact_date) : null;
  const isActionableDate = ds?.status === 'overdue' || ds?.status === 'today';
  const cadencia = Number(lead.followup_days) || 0; // follow-up recorrente, em dias
  const urgentBorder = repescando
    ? 'bg-indigo-50 border border-indigo-300 anim-repescagem'
    : ds?.status==='overdue'
    ? 'bg-red-50 border border-red-300'
    : ds?.status==='today'
    ? 'bg-orange-50 border border-orange-200'
    : 'acard';

  const interIcons = { ligacao:'📞', email:'📧', reuniao:'🤝', whatsapp:'💬', outro:'📝' };
  // Velocidade de pipeline: dias na etapa atual (C-33)
  const daysInStage = diasNaEtapa(lead);
  const esfriando   = statusEsfriando(lead);
  const recM = (lead.recurrence && lead.recurrence!=='unica') ? getRecMonths(lead.recurrence) : null;

  // Última interação e último marco (mais recente)
  const lastInter = lead.interactions?.length
    ? [...lead.interactions].sort((a,b)=>(b.created_at||b.date||'')>(a.created_at||a.date||'')?1:-1)[0]
    : null;
  const lastTL = lead.timeline?.length
    ? [...lead.timeline].sort((a,b)=>(b.date||b.created_at||'')>(a.date||a.created_at||'')?1:-1)[0]
    : null;
  const hasStatus = !!(lastInter || lastTL);

  const wa = fmtWhatsApp(lead.contact_phone);
  const nossa = rotuloEmpresa(company);
  const waHref = wa ? waLink(wa, renderWaTemplate(WA_TEMPLATES[0].text, lead, nossa)) : '';
  const origem = lead.origem ? LEAD_ORIGINS.find(x=>x.key===lead.origem) : null;

  const handleSnooze = (days, repeat, closeFn) => {
    closeFn(false);
    if (onSnoozeDate) onSnoozeDate(lead.id, days, repeat);
    else if (onClearDate) onClearDate(lead.id);
  };
  // ✓ com cadência reagenda em um clique; sem cadência abre o picker, como sempre.
  const handleCheck = (setShow, setOther) => {
    if (cadencia && onSnoozeDate) { onSnoozeDate(lead.id, cadencia, true); return; }
    setShow(v=>!v); setOther(false);
  };
  const tituloCheck = cadencia ? `Feito: reagenda em ${cadencia} dias` : 'Reagendar ou dispensar';
  const Ciclo = ({ setShow, setOther }) => cadencia > 0 && <button type="button"
    title={`Repete a cada ${cadencia} dias. Clique para mudar o ritmo ou encerrar`}
    onClick={e=>{e.stopPropagation(); setShow(v=>!v); setOther(false);}}
    className="t-caption-2 text-indigo-500 hover:text-indigo-700 leading-none px-0.5">
    <span aria-hidden="true">🔁</span><span className="sr-only">a cada {cadencia} dias</span>
  </button>;
  const handleDismiss = (closeFn) => {
    closeFn(false);
    if (onClearDate) onClearDate(lead.id);
  };

  return <div
    draggable={!!isDraggable}
    onDragStart={isDraggable ? (e=>e.dataTransfer.setData('leadId',lead.id)) : undefined}
    onClick={onClick}
    className={`rounded-2xl p-3 cursor-pointer hover:shadow-md transition-all select-none ${urgentBorder}`}
  >
    {/* Cabeçalho: nome + dias na etapa + WA */}
    <div className="flex items-center justify-between gap-1 mb-1">
      <div className="font-semibold text-gray-800 text-sm truncate flex-1 leading-tight">{lead.company_name}</div>
      <div className="flex items-center gap-1 flex-shrink-0">
        {campos.esfriando && esfriando && <span
          title={`${esfriando.label}: ${esfriando.dias} dias nesta etapa, o limite é ${esfriando.limite}`}
          className={`t-caption-2 font-semibold px-1.5 py-0.5 rounded-full border ${esfriando.cls}`}>
          <span aria-hidden="true">{esfriando.emoji}</span>{esfriando.dias}d
        </span>}
        {(lead.tasks||[]).some(t=>!t.done) && <span title="Próximos passos em aberto"
          className="t-caption-2 text-blue-600 bg-blue-50 px-1.5 py-0.5 rounded-full font-semibold">📌{(lead.tasks||[]).filter(t=>!t.done).length}</span>}
        {campos.whatsapp && wa && <CopiarContato lead={lead} company={company} compacto />}
        {campos.whatsapp && wa && <a href={waHref} target="_blank" rel="noopener noreferrer"
          onClick={e=>e.stopPropagation()} title={`WhatsApp ${lead.contact_phone}, já com a mensagem de primeiro contato`}
          className="flex items-center gap-0.5 bg-green-500 hover:bg-green-600 text-white t-caption-2 font-medium px-1.5 py-0.5 rounded-full transition-colors">
          {WA_ICON}
        </a>}
      </div>
    </div>

    {/* Faixa de destaque: proposta */}
    {campos.proposta && normalizeUrl(lead.proposal_url) && <a
      href={normalizeUrl(lead.proposal_url)} target="_blank" rel="noopener noreferrer"
      onClick={e=>e.stopPropagation()}
      aria-label={`Abrir proposta de ${lead.company_name} em nova guia`}
      title="Abrir proposta"
      className="flex items-center gap-1.5 w-full mb-1.5 px-2.5 py-1.5 rounded-xl bg-indigo-50 border border-indigo-200 text-indigo-700 hover:bg-indigo-100 hover:border-indigo-300 transition-colors">
      <span aria-hidden="true">📄</span>
      <span className="text-xs font-semibold flex-1 text-left">Ver proposta</span>
      <span aria-hidden="true" className="text-xs opacity-60">↗</span>
    </a>}

    {/* Linha 2: valor + temp + origem/seller compact */}
    <div className="flex items-center gap-2 mb-1.5 flex-wrap">
      {campos.valor && lead.value>0 && <span className="text-xs font-bold text-green-700 bg-green-50 px-2 py-0.5 rounded-full">
        {fmt(lead.value)}{recM?'/mês':''}
      </span>}
      {campos.origem && origem && <span className="text-xs text-amber-600" title={origem.label}>{origem.emoji}</span>}
      {campos.vendedor && lead.seller_name && <span className="t-caption-2 text-blue-600 bg-blue-50 px-1.5 py-0.5 rounded-full font-medium truncate max-w-[80px]" title={lead.seller_name}>
        👤{lead.seller_name.split(' ')[0]}
      </span>}
      {campos.vendedor && !lead.seller_id && !isFinalStage && <span className="t-caption-2 text-amber-700 bg-amber-50 px-1.5 py-0.5 rounded-full font-medium" title="Ninguém pegou este lead ainda">
        sem vendedor
      </span>}
      {isActionableDate && <div className="flex items-center gap-0.5 ml-auto" onClick={e=>e.stopPropagation()}>
        <DateBadge dateStr={lead.next_contact_date} />
        <Ciclo setShow={setShowSnoozeInfo} setOther={setShowSnoozeStatus} />
        {(onClearDate||onSnoozeDate) && <button
          title={tituloCheck}
          onClick={e=>{e.stopPropagation(); handleCheck(setShowSnoozeInfo, setShowSnoozeStatus);}}
          className={`w-5 h-5 flex items-center justify-center rounded-full t-caption-2 font-bold transition-all shadow-sm flex-shrink-0 ${showSnoozeInfo ? 'bg-blue-500 text-white border-blue-500' : 'bg-white border border-gray-200 text-gray-400 hover:bg-green-50 hover:border-green-300 hover:text-green-600'} border`}>
          ✓
        </button>}
      </div>}
    </div>
    {showSnoozeInfo && <SnoozePicker current={cadencia||null} onSnooze={(d,r)=>handleSnooze(d,r,setShowSnoozeInfo)} onDismiss={()=>handleDismiss(setShowSnoozeInfo)} />}

    {/* Temperatura do lead */}
    {campos.temperatura && onTemperatureChange && <div className="mb-2">
      <TempPicker current={lead.temperature||null} onChange={v=>onTemperatureChange(lead.id,'temperature',v)} />
    </div>}

    {/* Seletor de aba */}
    <div className="flex gap-0.5 mb-1.5 bg-black/[0.05] rounded-full p-0.5" onClick={e=>e.stopPropagation()}>
      <button onClick={e=>{e.stopPropagation();setCardTab('info');}}
        className={`flex-1 text-xs py-0.5 rounded-full font-medium transition-all ${cardTab==='info'?'bg-white text-gray-900 shadow-sm':'text-gray-400 hover:text-gray-600'}`}>
        Infos
      </button>
      <button onClick={e=>{e.stopPropagation();setCardTab('status');}}
        className={`flex-1 text-xs py-0.5 rounded-full font-medium transition-all relative ${cardTab==='status'?'bg-white text-gray-900 shadow-sm':'text-gray-400 hover:text-gray-600'}`}>
        Status
        {hasStatus && cardTab!=='status' && <span className="absolute top-0.5 right-1 w-1.5 h-1.5 bg-blue-500 rounded-full"/>}
      </button>
    </div>

    {/* Aba Info */}
    {cardTab==='info' && <>
      {campos.contato && lead.contact_name && <div className="text-xs text-gray-500 truncate mb-0.5">{lead.contact_name}</div>}
      {campos.servico && lead.service_type && <div className="text-xs text-indigo-600 font-medium truncate mb-0.5">🎯 {lead.service_type}</div>}
      {campos.previsao && lead.forecast_date && <div className="text-xs text-purple-600 font-medium truncate mb-0.5">
        🎯 {new Date(lead.forecast_date+'T00:00:00').toLocaleDateString('pt-BR')}
        {lead.forecast_prob ? ` · ${lead.forecast_prob}%` : ''}
      </div>}
      {camposCustom.filter(c=>c.no_card && lead.custom?.[c.key] != null && lead.custom[c.key] !== '').map(c=>
        <div key={c.key} className="text-xs text-gray-500 truncate mb-0.5" title={c.label}>{c.label}: <span className="font-medium text-gray-700">{valorParaMostrar(c, lead.custom[c.key])}</span></div>)}
      {lead.variable_rate>0 && <div className="text-xs text-indigo-600 mb-0.5">+{lead.variable_rate}% fat.</div>}
      {campos.parceiros && lead.partners?.length>0 && <div className="flex flex-col gap-1 mt-1">
        {lead.partners.map(p=>{
          const cv = p.commission_rate>0 && lead.value>0 ? Number(lead.value)*p.commission_rate/100 : null;
          return <div key={p.id} className="flex items-center justify-between bg-purple-50 border border-purple-100 rounded-lg px-2 py-1">
            <div className="flex flex-col min-w-0">
              <span className="text-xs text-purple-700 font-medium truncate">{p.name}</span>
              {p.consultant_name && <span className="t-caption-2 text-purple-400 truncate">↳ {p.consultant_name}</span>}
            </div>
            <div className="flex items-center gap-1.5 flex-shrink-0">
              {p.commission_rate>0 && <span className="text-xs text-purple-500">{p.commission_rate}%</span>}
              {cv!==null && <span className="text-xs font-semibold text-green-700 bg-green-50 rounded px-1.5 py-0.5">{fmt(cv)}</span>}
            </div>
          </div>;
        })}
      </div>}
      {!lead.contact_name && !lead.service_type && !lead.partners?.length && <p className="text-xs text-gray-400 italic py-1">Sem detalhes cadastrados</p>}
    </>}

    {/* Aba Status */}
    {cardTab==='status' && <div className="space-y-1.5 min-h-[48px]">
      {lastInter
        ? <div className="bg-gray-50 rounded-lg px-2 py-1.5">
            <div className="flex items-center gap-1 mb-0.5">
              <span>{interIcons[lastInter.type]||'📝'}</span>
              <span className="text-xs font-semibold text-gray-600 capitalize">{lastInter.type}</span>
              <span className="text-xs text-gray-400 ml-auto">{fmtDateOnly(lastInter.date)}</span>
            </div>
            {lastInter.note && <p className="text-xs text-gray-600 line-clamp-2">{lastInter.note}</p>}
          </div>
        : null}
      {lastTL
        ? <div className="bg-indigo-50 border border-indigo-100 rounded-lg px-2 py-1.5">
            <div className="text-xs text-indigo-500 font-semibold mb-0.5">📍 {fmtDateOnly(lastTL.date||lastTL.created_at?.slice(0,10))}</div>
            <p className="text-xs text-gray-600 line-clamp-2">{lastTL.text}</p>
          </div>
        : null}
      {!hasStatus && <p className="text-xs text-gray-400 text-center py-3 italic">Sem atualizações</p>}
      {ds && <div className="pt-0.5" onClick={e=>e.stopPropagation()}>
        <div className="flex items-center gap-1">
          <DateBadge dateStr={lead.next_contact_date} />
          <Ciclo setShow={setShowSnoozeStatus} setOther={setShowSnoozeInfo} />
          {isActionableDate && (onClearDate||onSnoozeDate) && <button
            title={tituloCheck}
            onClick={e=>{e.stopPropagation(); handleCheck(setShowSnoozeStatus, setShowSnoozeInfo);}}
            className={`w-5 h-5 flex items-center justify-center rounded-full t-caption-2 font-bold transition-all shadow-sm flex-shrink-0 ${showSnoozeStatus ? 'bg-blue-500 text-white border-blue-500' : 'bg-white border border-gray-200 text-gray-400 hover:bg-green-50 hover:border-green-300 hover:text-green-600'} border`}>
            ✓
          </button>}
        </div>
        {showSnoozeStatus && <SnoozePicker current={cadencia||null} onSnooze={(d,r)=>handleSnooze(d,r,setShowSnoozeStatus)} onDismiss={()=>handleDismiss(setShowSnoozeStatus)} />}
      </div>}
    </div>}

    {/* Botão + para registrar status rápido */}
    {onAddInteraction && <div className="relative mt-2" onClick={e=>e.stopPropagation()}>
      {showQuickStatus && <QuickStatusPopup
        leadId={lead.id}
        onSave={onAddInteraction}
        onClose={()=>setShowQuickStatus(false)}
      />}
      <button
        onClick={e=>{e.stopPropagation(); setShowQuickStatus(o=>!o);}}
        title="Registrar interação"
        className={`w-full flex items-center justify-center gap-1.5 py-1.5 rounded-xl text-xs font-semibold transition-all border ${
          showQuickStatus
            ? 'bg-blue-600 text-white border-blue-600'
            : 'bg-gray-50 text-gray-400 border-gray-200 hover:bg-blue-50 hover:text-blue-600 hover:border-blue-200'
        }`}
      >
        <span className="text-base leading-none">{showQuickStatus ? '✕' : '+'}</span>
        {showQuickStatus ? 'Cancelar' : 'Registrar status'}
      </button>
    </div>}
  </div>;
}

// ─── KanbanView ───────────────────────────────────────────

export { KanbanCard };
